import { isFunction } from 'lodash'

/* eslint-disable import/prefer-default-export */
type Validator = (value: unknown) => boolean
type Transformer = (value: unknown) => unknown

type SinglePath<K> = {
  key: K
  validator?: Validator
  transformer?: Transformer
}

type MultiplePath<K> = {
  keys: Array<K>
  validator?: Validator
  transformer?: Transformer
}

type Path<K> = SinglePath<K> | MultiplePath<K>

function isValid(value: unknown, validator?: Validator) {
  if (!validator) {
    return true
  }

  return validator(value)
}

export function pickValidFields<T extends Record<string, any>, K extends keyof T>(obj: T, paths: Path<K>[]) {
  return paths.reduce((acc, path) => {
    const keys = 'keys' in path ? path.keys : [path.key]

    keys.forEach((key) => {
      const value = obj[key]

      if (value !== undefined && isValid(value, path.validator)) {
        acc[key] = isFunction(path.transformer) ? (path.transformer(value) as T[K]) : value
      }
    })

    return acc
  }, {} as Partial<Pick<T, K>>)
}
